<template>
  <div>
    <strong>{{ store.state.filteredArticles.length }}</strong> Result[s] found
    matching
    {{
      store.state.lowLevelTerm != ""
        ? store.state.lowLevelTerm
        : store.state.midLevelTerm
    }}
    <br />
    <div class="articles">
      <Table
        :articles="store.state.filteredArticles"
        :key="store.state.filteredArticles.length"
      />
    </div>
    <p>
    * deemed most relevant to the AREA Research Agenda
    </p>
    <Coocurences v-if="!store.state.selectedArticle" />
  </div>
</template>
<script>
import Coocurences from "./Cooccurences";
import Table from "./Table";
import { store } from "../store";

export default {
  name: "Articles",
  components: {
    Coocurences,
    Table
  },
  data() {
    return {
      store
    };
  }
};
</script>
<style>

tr,
td {
  padding: 5px;
}
tr:nth-child(2n) {
  background: #DFF1F3;
}
.article-title {
  cursor: pointer;
  font-weight: bold;
  font-style: italic;
}
.articles {
  overflow-y: scroll;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  min-height: 300px;
  max-height: 300px;
  margin-top: 50px;
  margin-bottom: 50px;
}
.term {
  background: gainsboro;
  padding: 5px;
  border: 2px solid white;
  text-align: center;
  font-weight: bold;
  font-style: italic;
  cursor: pointer;
  line-height: 35px;
  display: inline-block;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.flex {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
}
.flex li {
  background: gainsboro;
  padding: 5px;
  border: 2px solid white;
  text-align: center;
  font-weight: bold;
  font-style: italic;
  cursor: pointer;
}
.flex li:hover,
.term:hover {
  color: #0a3a4a;
  background: white;
}
</style>
